import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
// Routes
import * as routes from "routes/routes";
import CustomRoute from "routes/customRoute";

// Pages
import TrainerSignup from "pages/TrainerSignup/TrainerSignup";
import Login from "pages/login/Login";
import Dashboard from "pages/dashboard/Dashboard";
import Information from "pages/information/Information";
import WhatAwaitsYou from "pages/whatAwaitsYou/WhatAwaitsYou";
import Registration from "pages/registration/Registration";
import NutritionCreation from "pages/nutritionCreation/NutritionCreation";
import NutritionForm from "pages/nurtritionForm/NutritionForm";
import FormAdvantages from "pages/formAdvantages/FormAdvantages";
import NutritionRecipes from "pages/nutritionRecipes/NutritionRecipes";
import NutritionCalories from "pages/nutritionCalories/NutritionCalories";
import MacroNutrients from "pages/macroNutritients/MacroNutrients";
import NutritionDone from "pages/nutritionDone/NutritionDone";
import HealthScoreInvestigation from "pages/healthScoreInvestigation/HealthScoreInvestigation";
import HealthScoreImprovement from "pages/healthScoreImprovement/HealthScoreImprovement";
import Overview from "pages/overview/Overview";
import OverviewBasic from "pages/overviewBasic/OverviewBasic";
import OrderDetails from "pages/orderDetails/OrderDetails";
import FoodiaryFamily from "pages/fooddiaryFamily/FoodiaryFamily";
import PremiumCoaching from "pages/premiumCoaching/PremiumCoaching";
import PremiumCoachingSuccess from "pages/premiumCoachingSuccess/PremiumCoachingSuccess";
import HealthScoreTips from "pages/healthScoreTips/HealthScoreTips";
import HealthScorePriority from "pages/healthScorePriority/HealthScorePriority";
import HealthScoreEvaluation from "pages/healthScoreEvaluation/HealthScoreEvaluation";
import HealthScoreDailyBudget from "pages/healthScoreDailyBudget/HealthScoreDailyBudget";
import Supplements from "pages/supplements/Supplements";
import ChangePassword from "pages/changePassword/ChangePassword";
import Subscription from "pages/Subscription/Subscription";
import SubscriptionDetails from "pages/subscriptionDetails/SubscriptionDetails";
import Start from "pages/start/start";
import ClientSuccessful from "pages/clientSuccessful/clientSuccessful";
import SelectCoach from "pages/selectCoach/selectCoach";
import Payment from "pages/payment/payment";
import ONBOARDING_ROUTES from "routes/onboardingRoutes";
import OnboardingWrapper from "pages/onboarding/wrapper/OnboardingWrapper";
import Gender from "pages/onboarding/gender/Gender";

const App = () => {
  // useEffect(()=> {
  //   /* global google */
  //   google.accounts.id.initialize({
  //     client_id: "706005637370-bisnrpfi1in2p3ud7t419mpjm7ctvfbg.apps.googleusercontent.com",
  //     callback: handleCallbackResponse
  //   })
  // })
  return (
    <div style={{ position: "relative" }}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#2ECF96",
            colorLink: "#73BCAE",
            colorTextHeading: "#73BCAE",
            colorTextLabel: "#73BCAE",
            colorTextSecondary: "#73BCAE",
          },
        }}
      >
        <Router>
          <Switch>
            {/* <CustomRoute
              path={routes.TRAINER_SIGNUP}
              exact
              component={TrainerSignup}
            />
            <CustomRoute path={routes.LOGIN} exact component={Login} />
            <CustomRoute
              path={routes.CHANGE_PASSWORD}
              exact
              component={ChangePassword}
            />
            <CustomRoute
              restricted
              path={routes.DASHBOARD}
              exact
              component={Dashboard}
            />
            <CustomRoute
              restricted
              path={routes.WHAT_AWAITS_YOU}
              exact
              component={WhatAwaitsYou}
            />
            <CustomRoute
              path={routes.REGISTRATION}
              exact
              component={Registration}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_CREATION}
              exact
              component={NutritionCreation}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_FORM}
              exact
              component={NutritionForm}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_FORM_ADVANTAGES}
              exact
              component={FormAdvantages}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_RECIPES}
              exact
              component={NutritionRecipes}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_CALORIES}
              exact
              component={NutritionCalories}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_MACRO_NUTRIENTS}
              exact
              component={MacroNutrients}
            />
            <CustomRoute
              restricted
              path={routes.NUTRITION_DONE}
              exact
              component={NutritionDone}
            />
            <CustomRoute
              restricted
              path={routes.HEALTH_SCORE_INVESTIGATION}
              exact
              component={HealthScoreInvestigation}
            />
            <CustomRoute
              restricted
              path={routes.HEALTH_SCORE_IMPROVEMENT}
              exact
              component={HealthScoreImprovement}
            />
            <CustomRoute
              restricted
              path={routes.OVERVIEW}
              exact
              component={Overview}
            />
            <CustomRoute
              restricted
              path={routes.OVERVIEW_BASIC}
              exact
              component={OverviewBasic}
            />
            <CustomRoute
              restricted
              path={routes.ORDER_DETAILS}
              exact
              component={OrderDetails}
            />
            <CustomRoute
              restricted
              path={routes.FOODIARY_FAMILY}
              exact
              component={FoodiaryFamily}
            />
            <CustomRoute
              restricted
              path={routes.PREMIUM_COACHING}
              exact
              component={PremiumCoaching}
            />
            <CustomRoute
              restricted
              path={routes.PREMIUM_COACHING_SUCCESS}
              exact
              component={PremiumCoachingSuccess}
            />
            <CustomRoute
              restricted
              path={routes.HEALTH_SCORE_TIPS}
              exact
              component={HealthScoreTips}
            />
            <CustomRoute
              restricted
              path={routes.HEALTH_SCORE_PRIORITY}
              exact
              component={HealthScorePriority}
            />
            <CustomRoute
              restricted
              path={routes.HEALTH_SCORE_EVALUATION}
              exact
              component={HealthScoreEvaluation}
            />
            <CustomRoute
              restricted
              path={routes.HEALTH_SCORE_DAILY_BUDGET}
              exact
              component={HealthScoreDailyBudget}
            />
            <CustomRoute
              restricted
              path={routes.SUPPLEMENTS}
              exact
              component={Supplements}
            />
            <CustomRoute
              restricted
              path={routes.SUBSCRIPTIONS}
              exact
              component={Subscription}
            />
            <CustomRoute
              restricted
              path={routes.SUBSCRIPTIONS_DETAILS}
              exact
              component={SubscriptionDetails}
            />
            <CustomRoute path={routes.START} exact component={Start} />
            <CustomRoute
              path={routes.CLIENT_SUCCESSFUL}
              exact
              component={ClientSuccessful}
            />
            <CustomRoute
              path={routes.SELECT_COACH}
              exact
              component={SelectCoach}
            />
            <CustomRoute path={routes.PAYMENT} exact component={Payment} /> */}
            <CustomRoute
              path={"/"}
              exact
              component={() => (
                <OnboardingWrapper
                  children={<Gender />}
                  currentPath={"/onboarding/gender"}
                  progressStep={0}
                />
              )}
            />
            {ONBOARDING_ROUTES.map((route) => (
              <CustomRoute
                key={route.path}
                path={route.path}
                exact
                component={() => (
                  <OnboardingWrapper
                    children={<route.component />}
                    currentPath={route.path}
                    progressStep={route.progressStep}
                  />
                )}
              />
            ))}
            <Route path="/" render={() => "Route Not Found"} />
          </Switch>
        </Router>
      </ConfigProvider>
    </div>
  );
};

export default App;
